var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes, st } from './IconTooltip.st.css';
import { ButtonNext } from 'wix-ui-core/dist/es/src/components/button-next';
import { uid } from 'react-uid';
import { Tooltip } from '../Tooltip';
import { TooltipSkin } from '../Tooltip/types';
/** An icon that shows a tooltip on focus and on hover. */
export class IconTooltip extends React.Component {
    render() {
        const _a = this.props, { message, icon, tooltipId, tooltipSkin, showTooltip, onClickOutside, tooltipProps, 'data-hook': dataHook, className } = _a, rest = __rest(_a, ["message", "icon", "tooltipId", "tooltipSkin", "showTooltip", "onClickOutside", "tooltipProps", 'data-hook', "className"]);
        const content = React.createElement("span", { id: tooltipId }, message);
        return (React.createElement(Tooltip, Object.assign({ className: st(classes.root, {}, className), "data-hook": dataHook, "aria-live": "polite", disabled: !showTooltip, content: content, appendTo: "scrollParent", skin: tooltipSkin, shown: showTooltip, onClickOutside: onClickOutside, disableClickOutsideWhenClosed: true }, tooltipProps),
            React.createElement(React.Fragment, null,
                React.createElement(ButtonNext, Object.assign({ className: classes.button, "aria-pressed": showTooltip, "aria-labelledby": tooltipId }, rest),
                    React.createElement("div", { className: classes.icon }, icon)),
                !showTooltip ? (React.createElement("span", { id: tooltipId, className: classes.tooltipMessage }, message)) : null)));
    }
}
IconTooltip.displayName = 'IconTooltip';
IconTooltip.defaultProps = {
    message: '',
    icon: undefined,
    tooltipId: uid(IconTooltip.displayName),
    tooltipSkin: TooltipSkin.Standard,
    showTooltip: false,
};
//# sourceMappingURL=IconTooltip.js.map